export function roundUpToNearestFifteenMinutes(timeStamp) {
    const date = new Date(timeStamp);
    const minutes = date.getMinutes();
    const remainder = minutes % 15;
    const addMinutes = remainder === 0 ? 0 : 15 - remainder;
    date.setMinutes(minutes + addMinutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    /**
     * Increase time by an additional 15 minutes if remainder to next step is less than 10 minutes.
     * This is needed because backend processing jobs might not have enough time to process everything if there are less than 10 mins left to schedule
     * and race conditions may appear.
     **/
    if (date.getTime() - timeStamp < 600000) {
        const newTime = minutes + addMinutes + 15;
        if (newTime > 59) {
            /**
             * If next step is too big we might have to jump straight to the next 15 minute mark
             * Otherwise, we set the hour to +1 and reset the minutes
             * */
            const minutesOfTheNextHour = newTime - 60;
            if (minutesOfTheNextHour > 5) {
                date.setMinutes(15);
            }
            else {
                date.setMinutes(0);
                date.setHours(date.getHours() + 1);
            }
        }
        else {
            date.setMinutes(minutes + addMinutes + 15);
        }
    }
    return date.getTime();
}
